import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import reduxThunk from "redux-thunk";
import { createBrowserHistory } from "history";

import createReducer from "./reducers";

import { APP_NAME, APP_HOST } from "./config";
const { NODE_ENV } = process.env;

export const history = createBrowserHistory();

// TODO Check history correct type
export default function configureStore(initialState = {}) {
  const middlewares = [routerMiddleware(history), reduxThunk];
  const enhancers = [applyMiddleware(...middlewares)];

  const composeEnhancers = composeWithDevTools({
    // Specify here name, actionsBlacklist, actionsCreators and other options
    shouldHotReload: false,
    trace: NODE_ENV === "production" ? false : true,
    name: `${APP_NAME} [${APP_HOST}]`,
  });

  const store = createStore(
    createReducer(history),
    initialState,
    composeEnhancers(...enhancers),
  );

  return store;
}
